import React from 'react';
// template components
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import CaratRight from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/CaratRight';
// styles
import { ColStyled } from './styles';

export default () => {
  return (
    <SectionContainer
      id='prospectus-and-reports-intro'
      backgroundVariant='lightA'
      themeType='lightTheme'
      disableBottomPadding>
      <Row align='center'>
        <ColStyled medium={8}>
          <Typography
            component='h1'
            align='center'
            nextElement='typography'>
            Variable Annuity Prospectuses <WidowBlock>and Reports</WidowBlock>
          </Typography>
          <Typography
            nextElement='typography'
            component='h2'
            align='center'>
            Prospectuses, Reports and additional documents
          </Typography>
          <Typography nextElement='typography'>
            Visit{' '}
            <Link
              id='nm-variable-annuity-variable-life-insurance-link'
              variant='primaryDeemphasize'
              linkUrl='https://connect.rightprospectus.com/northwesternmutual/'
              ariaLabel='read about Northwestern Mutual&#39;s variable annuity and variable life insurance products followed by documents for each underlying investment option available within them.'>
              www.nmprospectus.com
            </Link>
            {' '}to access prospectuses, offering circulars, statements of additional information, annual &#38; semiannual reports, and other documents related to Northwestern Mutual variable annuity products and the underlying fund options available within them.
          </Typography>
          <Typography nextElement='typography'>
            <Link
              id='annuities-prospectus-and-reports-download-variable-annuity-link'
              variant='primaryDeemphasize'
              linkUrl='/assets/pdf/financial-reports/annuities-prospectus-and-reports/va-ann-annual.pdf'
              isInternalPdf
              endAdornment={CaratRight}
              endAdornmentStylesReset>
              Download Variable Annuity Annual Reports
            </Link>
          </Typography>
          <Typography nextElement='typography'>
            <Link
              id='annuities-prospectus-and-reports-va-ann-semiannual-link'
              variant='primaryDeemphasize'
              linkUrl='/assets/pdf/financial-reports/annuities-prospectus-and-reports/va-ann-semiannual.pdf'
              isInternalPdf
              endAdornment={CaratRight}
              endAdornmentStylesReset>
              Download Variable Annuity Semi&#45;Annual Reports
            </Link>
          </Typography>
          <Typography nextElement='typography'>
            <Link
              id='annuities-prospectus-and-reports-annuity-account-a-offering-circular-link'
              variant='primaryDeemphasize'
              linkUrl='/assets/pdf/financial-reports/annuities-prospectus-and-reports/annuity-account-A-offering-circular.pdf'
              isInternalPdf
              endAdornment={CaratRight}
              endAdornmentStylesReset>
              Download Variable Annuity Account A Offering Circular
            </Link>
          </Typography>
          <Typography nextElement='typography'>
            <Link
              id='annuities-prospectus-and-reports-annuity-account-c-offering-circular-link'
              variant='primaryDeemphasize'
              linkUrl='/assets/pdf/financial-reports/annuities-prospectus-and-reports/annuity-account-c-offering-circular.pdf'
              isInternalPdf
              endAdornment={CaratRight}
              endAdornmentStylesReset>
              Download Variable Annuity Account C Offering Circular
            </Link>
          </Typography>
          <Typography disableBottomPadding>
            Variable annuities are offered and sold by prospectus only. Carefully consider the investment objectives, risks, expenses and charges of the investment company before investing. Your Northwestern Mutual Investment Services Registered Representative can provide you with a contract prospectus &#40;or offering circular&#41; as well as prospectuses for the funds that will contain the information noted above, and other important information that you should read carefully before you invest or send money.
          </Typography>
        </ColStyled>
      </Row>
    </SectionContainer>
  );
};
